import type { RingCall } from './ringAnswer';

/**
 * Which phones this module does NOT hold — because the dashboard's shell does.
 * Each is answered separately: a parent may host one and not the other, and a
 * card for a hosted phone is a card whose Answer can only ever fail.
 */
export interface HostedPhones {
  phone: boolean;
  dialer: boolean;
}

/**
 * The ring cards this module raises, out of everything the socket reported.
 *
 * A card is only worth drawing for a call a phone in THIS module can pick up.
 * When the dashboard holds a phone, it also raises its own card for that
 * phone's calls — on every page, this one included — so a card here would be a
 * second ring for one call with a dead Answer beside it. The rule is per
 * provider, not all-or-nothing: a parent hosting the dialer but not the phone
 * (or the other way round) still gets the cards its module can act on.
 *
 * The ringtone follows this list, so filtering here is also what keeps the two
 * apps from ringing over each other.
 */
export function visibleRings(rings: RingCall[], hosted: HostedPhones): RingCall[] {
  if (!hosted.phone && !hosted.dialer) return rings;
  return rings.filter((ring) =>
    ring.provider === 'twilio' ? !hosted.phone : !hosted.dialer,
  );
}
